var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketDonation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.513,
    height: 15.661,
    viewBox: "0 0 14.513 15.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10831",
    "data-name": "Group 10831",
    transform: "translate(0.401 0.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5392",
    "data-name": "Path 5392",
    d: "M-311.286,497.609c-.692-1.731-2.25-3.172-3.592-4.5",
    transform: "translate(320.633 -489.604)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5393",
    "data-name": "Path 5393",
    d: "M-321.009,507.13v.346a.692.692,0,0,0,.692.692h.692a.692.692,0,0,0,.692-.692v-.54a.692.692,0,0,0-.474-.657l-1.13-.377a.693.693,0,0,1-.474-.657v-.539a.692.692,0,0,1,.692-.692h.692a.692.692,0,0,1,.692.692v.346",
    transform: "translate(324.817 -497.048)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_639",
    "data-name": "Line 639",
    y1: 1.039,
    transform: "translate(4.846 5.928)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_640",
    "data-name": "Line 640",
    y2: 1.039,
    transform: "translate(4.846 11.121)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5394",
    "data-name": "Path 5394",
    d: "M-321.613,485.616c-.109.189-.625.318-.909.318a1.435,1.435,0,0,1-.909-.318s-1.366-2.759-1.316-2.859c.442-.895,1.363-.722,2.226-.476a5.1,5.1,0,0,0,1.954.275A25.207,25.207,0,0,1-321.613,485.616Z",
    transform: "translate(327.368 -482.083)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5395",
    "data-name": "Path 5395",
    d: "M-329.06,493.105c-2.129,2.11-3.936,4.68-3.938,6.611,0,2.67,2.167,3.778,4.847,3.778,3.462,0,5.259-3.2,5.259-3.2l-1.23-1.23,4.715-1.025-1.025,4.715-1.025-1.025-.615.615a12.589,12.589,0,0,1-3.655,2.185",
    transform: "translate(332.997 -489.604)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketDonation);
export default __webpack_public_path__ + "static/media/ticketDonation.e1a0a3894267316c235b7c3222628b4c.svg";
export { ForwardRef as ReactComponent };